/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import about from './en/about.json';
import admin from './en/admin.json';
import cluster from './en/cluster.json';
import common from './en/common.json';
import confirmationPage from './en/confirmation-page.json';
import createCluster from './en/create-cluster.json';
import createOrganization from './en/create-organization.json';
import createProject from './en/create-project.json';
import entities from './en/entities.json';
import general from './en/general.json';
import login from './en/login.json';
import navigation from './en/navigation.json';
import organizationAdmin from './en/organization-admin.json';
import project from './en/project.json';
import rbac from './en/rbac.json';
import setup from './en/setup.json';
import userProfile from './en/user-profile.json';
import validation from './en/validation.json';
import { findCountryLocalizations } from './index';

export const enTranslation = {
  about,
  admin,
  cluster,
  common,
  confirmationPage,
  countries: findCountryLocalizations('en'),
  createCluster,
  createOrganization,
  createProject,
  entities,
  general,
  login,
  navigation,
  organizationAdmin,
  project,
  rbac,
  setup,
  userProfile,
  validation,
};
